import { render, staticRenderFns } from "./PcqDsisTable.vue?vue&type=template&id=6860d2d0&"
import script from "./PcqDsisTable.vue?vue&type=script&lang=js&"
export * from "./PcqDsisTable.vue?vue&type=script&lang=js&"
import style0 from "./PcqDsisTable.vue?vue&type=style&index=0&id=6860d2d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports